import React, { useEffect, useRef, useState } from "react";
import ExecutiveContactDetails from "../../../common/form/executiveContactDetails";
import ActionSection from "features/terminal-details/common/actionSection";
import { TerminalState } from "../../../../slices/terminal-summary/TerminalDetailsState";
import { terminalDetailsSelector } from "../../../../slices/terminal-summary/terminalDetailsSlice";
import { useSelector } from "react-redux";
import { Form, Formik, FormikProps } from "formik";
import { getRegionValidationForAddTerminal, Region as RegionModel } from "../../../../app/data/terminal-details/models";
import { updateRegionSelector, updateTerminalRegionById } from "../../../../slices/terminal-summary/regionSlice";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { UpdateRegionState } from "../../../../slices/terminal-summary/RegionState";
import { getTerminalSummaryByTerminalNumber } from "../../../../slices/terminal-summary/terminalDetailsSlice";
import { Divider } from "features/terminal-details/common/divider";
import { Region } from "features/common/form/region";
import { toast } from "react-toastify";

export default function EditRegion({ onClose }: { onClose: () => void }): React.ReactElement {
    const [spinner, setSpinner] = useState<boolean>(false);
    const terminalState: TerminalState = useSelector(terminalDetailsSelector);
    const updateRegionState: UpdateRegionState = useSelector(updateRegionSelector);
    const dispatch = useDispatch();
    const formRef = useRef<FormikProps<RegionModel>>(null);

    const handleSpinner = () => {
        setTimeout(() => {
            setSpinner(false);
        }, 1000);
    };

    useEffect(() => {
        if (updateRegionState.isSuccess) {
            dispatch(getTerminalSummaryByTerminalNumber(terminalState.data?.terminalNumber?.toString() || ""));

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateRegionState, dispatch]);

    const handleClear = () => {
        formRef.current?.resetForm();
    };

    const initialValues: RegionModel = {
        regionName: terminalState?.data?.region?.regionName || '',
        vpName: terminalState?.data?.region?.vpName || '',
        vpPhone: terminalState?.data?.region?.vpPhone || '',
        vpEmail: terminalState?.data?.region?.vpEmail || '',
        directorName: terminalState?.data?.region?.directorName || '',
        directorPhone: terminalState?.data?.region?.directorPhone || '',
        directorEmail: terminalState?.data?.region?.directorEmail || ''
    };

    return <>{terminalState?.data?.region && <Formik
        onSubmit={() => { }}
        initialValues={initialValues}
        validationSchema={getRegionValidationForAddTerminal()}
        innerRef={formRef}
        enableReinitialize={true}
    >
        {(formikProps: FormikProps<RegionModel>) => (

            <Form>
                <Region />
                <div className="margin-bottom-28" />
                <div className="form-heading">Vice President Details</div>
                <Divider className="margin-20" />
                <ExecutiveContactDetails executive="vp" required={false} label="Vice President"/>
                <div className="margin-bottom-28" />
                <div className="form-heading">Director Details</div>
                <Divider className="margin-20" />
                <ExecutiveContactDetails executive="director" required={false} label="Director" />
                <div className="action-section">
                <ActionSection
                    handleClear={handleClear}
                    handleSave={async () => {
                        setSpinner(true);
                        const values = formRef.current?.values;

                        await Promise.all([
                            formRef?.current?.submitForm()
                        ]);
                        handleSpinner();

                        const isValid = terminalState.data?.region?.id && terminalState.data?.terminalNumber && _.isEmpty(formRef.current?.errors);
                        if (isValid) {
                            dispatch(updateTerminalRegionById(terminalState.data?.terminalNumber?.toString() || "", terminalState.data?.region?.id || "", {
                                regionName: values?.regionName || "",
                                vpName: values?.vpName || null,
                                vpPhone: values?.vpPhone || null,
                                vpEmail: values?.vpEmail || null,
                                directorName: values?.directorName || null,
                                directorPhone: values?.directorPhone || null,
                                directorEmail: values?.directorEmail || null
                            }, () => {
                                toast.info("Updated details");
                            }, (message: string | object) => {
                                toast.error(message);
                            }));
                        }
                    }}
                    disabled={!formikProps.dirty}
                    spinner={updateRegionState.isLoading || spinner}
                />
                </div>
            </Form>)}
    </Formik>
    }</>

}
